<template>
  <Modal v-model="modalVisible" footer-hide width="1000">
    <p slot="header" class="text-center">
      <span>任务附件</span>
    </p>
    <Row>
      <i-col span="24">
        <Upload
          ref="uploadRef"
          type="drag"
          :headers="headers"
          :action="uploadUrl"
          :format="format"
          :max-size="maxSize"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleExceedMaxsize"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemoveFile"
        >
          <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>点击或拖拽文件到这里进行上传</p>
          </div>
        </Upload>
      </i-col>
    </Row>
    <p class="p-t-10">
      <i-button size="small" type="success" :disabled="uploadList.length < 1" @click="handleSaveAttach">确认上传</i-button>
    </p>
    <div class="tips m-t-10 remark">
      支持格式：jpg、png、jpeg、pdf、doc、docx、xls、xlsx，单个文件不超过100MB
    </div>
    <div class="text-16 m-t-10">
      附件历史
      <Divider style="margin: 5px 0;"/>
      <List v-if="historyAttach.length > 0">
        <ListItem v-for="(item, index) in historyAttach" :key="index">
          <ListItemMeta :title="item.createTime + '（' + item.userName + '）'">
            <div slot="description">
              <a v-for="file in item.contentList" :key="file.attachId" class="m-r-20"
                @click="handleDownloadFile(file)">{{ file.name }}</a>
            </div>
          </ListItemMeta>
        </ListItem>
      </List>
      <p v-else class="text-center remark p-t-10">暂无数据</p>
    </div>
  </Modal>
</template>

<script>
import { getStorage } from '@/utils/storage'
import { signurlByAttach } from '@/api/resource/endpoint'
import { downloadFileRequest } from '@/utils/download'
import { getTaskAttachList, addTaskAttach } from '@/api/msp/taskAttach'

export default {
  data () {
    return {
      modalVisible: false,
      taskId: 0,
      uploadUrl: `${process.env.VUE_APP_API_URL_V2}/ooh-resource/oss/endpoint/put-file-attach`,
      headers: {
        'ooh-auth': getStorage('ooh-token')
      },
      format: ['jpg', 'png', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx'],
      maxSize: 102400,
      uploadList: [],
      historyAttach: []
    }
  },
  methods: {
    showModal (taskId) {
      this.modalVisible = true
      this.taskId = taskId
      this.uploadList = []
      this.$nextTick(() => {
        this.$refs.uploadRef.clearFiles()
      })
      this.loadAttachList()
    },
    loadAttachList () {
      getTaskAttachList({ taskId: this.taskId }).then(res => {
        this.historyAttach = res || []
      })
    },
    handleUploadSuccess (response, file, fileList) {
      const files = []
      fileList.forEach(x => {
        files.push({
          name: x.name,
          attachId: x.response.data.id
        })
      })
      this.uploadList = files
    },
    handleRemoveFile (file, fileList) {
      const files = []
      fileList.forEach(x => {
        files.push({
          name: x.name,
          attachId: x.response.data.id
        })
      })
      this.uploadList = files
    },
    handleFormatError () {
      this.$Notice.warning({ desc: '文件格式不支持，仅支持jpg、png、jpeg、pdf、doc、docx、xls、xlsx格式' })
    },
    handleExceedMaxsize () {
      this.$Notice.warning({ desc: '单个文件大小不能超过100MB' })
    },
    handleDownloadFile (file) {
      signurlByAttach({ attachId: file.attachId }).then(res => {
        downloadFileRequest(res.data, {}, file.name)
      })
    },
    handleSaveAttach () {
      const saveBean = {
        attaches: JSON.stringify(this.uploadList),
        taskId: this.taskId
      }
      addTaskAttach(saveBean).then(res => {
        this.loadAttachList()
        this.uploadList = []
        this.$refs.uploadRef.clearFiles()
        this.$Notice.success({ desc: '附件上传成功！' })
      })
    }
  }
}
</script>
